export default __webpack_public_path__ + "static/media/blackPoint.5f69aa6a.svg";